import { showDialog, showDialogWithData } from "../../../redux/guest-slices/other.slice";
import { handleRetrieveWebinars } from "../../../redux/public-slices/webinar.slice";
import TablePagination from "../../../components/common/TablePagination";
import { CREATE_BOOKING, GUEST_LOGIN } from "../../../utils/keywords";
import { checkUserType, FILE_PATH_URI } from "../../../utils/helper";
import SectionSkeleton from "../../../components/ui/SectionSkeleton";
import { Box, Container, Grid2 as Grid, Alert } from "@mui/material";
import { Fragment, lazy, Suspense, useState, useMemo } from "react";
import SkeletonImage from "../../../components/ui/SkeletonImage";
import ContentCard from "../../../components/common/Content";
import { useDispatch, useSelector } from "react-redux";
import Images from "../../../assets/js/Images";
import { useParams } from "react-router-dom";

const TopBannerB = lazy(() => import("../../../components/common/TopBannerB"));

const WebinarCategory = () => {
  const dispatch = useDispatch();
  const { categoryId } = useParams();
  const [data, setData] = useState([]);
  const { loadings } = useSelector((state) => state.otherSlice);

  const handleRetrieveAll = async (filters) => {
    const response = await dispatch(
      handleRetrieveWebinars({
        categoryId,
        currentPage: filters?.currentPage || null,
      })
    ).unwrap();
    setData(response);
  };

  useMemo(() => {
    handleRetrieveAll();
    // eslint-disable-next-line
  }, [categoryId]);
  const handleLogin = () => {
    dispatch(showDialog(GUEST_LOGIN));
  };

  const handleBooking = (webinarId) => {
    if (checkUserType()) {
      dispatch(
        showDialogWithData({
          type: CREATE_BOOKING,
          data: { webinarId },
        })
      );
    } else {
      handleLogin();
    }
  };
  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          bannerImg={Images?.forumImg4}
          headline={`Webinars Category`}
        />
      </Suspense>

      <Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
        <Container maxWidth={false}>
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, laptop: 8 }}>
              <Box
                sx={{
                  ml: "auto",
                  maxWidth: "1000px",
                  height: "fit-content",
                  position: "sticky",
                  top: 20,
                  overflowY: "auto",
                }}
              >
                <Grid container spacing={2}>
                  {loadings?.retrieveAll ? (
                    new Array(4).fill().map((_, i) => (
                      <Grid key={i} size={{ xs: 12, md: 6 }}>
                        <SkeletonImage />
                      </Grid>
                    ))
                  ) : data?.records?.length === 0 ? (
                    <Grid size={12}>
                      <Alert color="error" severity="error">
                        No Records Found!
                      </Alert>
                    </Grid>
                  ) : (
                    data?.records?.map((webinar, i) => (
                      <Grid key={webinar._id} size={{ xs: 12, md: 6 }}>
                        <ContentCard
                          id={webinar._id}
                          title={webinar.details.title}
                          image={
                            webinar.details.coverImage?.path
                              ? FILE_PATH_URI + webinar.details.coverImage.path
                              : Images?.blogs
                          }
                          date={webinar.schedule.startTime}
                          type="webinar"
                          onClickButton={() => handleBooking(webinar._id)}
                          buttonText={webinar.isBooked ? "Booked" : "Book now"}
                          buttonDisabled={webinar.isBooked}
                        />
                      </Grid>
                    ))
                  )}
                </Grid>

                <TablePagination
                  pagination={data?.pagination}
                  length={data?.records?.length}
                  loading={loadings?.retrieveAll}
                  cb={handleRetrieveAll}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Fragment>
  );
};

export default WebinarCategory;
